import { autoMount } from '../../../utils/autoMount';
import { UnsubscribePage } from '../../../components/pages/unsubscribePage';

autoMount({ UnsubscribePage });
